<template>
  <section class="our-services">
    <h2 class="title">Наши сервисы</h2>

    <div class="cards">
      <a v-for="(card, idx) in services" :key="idx" class="card" :href="card.link" target="_blank">
        <h4 class="name">{{ card.name }}</h4>
        <p class="text">{{ card.description }}</p>
        <NuxtImg class="image" :src="card.image" :alt="card.name" format="webp" loading="lazy" />
      </a>
    </div>
  </section>
</template>

<script lang="ts" setup>

  type Service = {
    name: string
    description: string
    image: string
    link: string
  }

  const services: Service[] = [
    {
      name: 'Карьерные маршруты',
      description: 'Поможем выбрать профессию мечты, улучшить навыки и найти работу',
      image: '/our-services/career-paths.png',
      link: 'https://svoevagro.ru/career-routes',
    },
    {
      name: 'Агроклассы',
      description:
        'Знакомься с сельским хозяйством со школьной скамьи, бесплатно готовься к ЕГЭ, участвуй в конкурсах',
      image: '/our-services/agroclasses.png',
      link: 'https://agroclasses.svoevagro.ru/?utm_source=svoevagro',
    },
    {
      name: 'Подбор вузов',
      description: 'Все учебные заведения России аграрного образования в одном месте',
      image: '/our-services/selection-of-universities.png',
      link: 'https://svoevagro.ru/universities',
    },
    {
      name: 'Золотой резерв',
      description:
        'Проявляй активность в проектах платформы, развивай свой проект и заявляй о себе на всю страну',
      image: '/our-services/golden-reserve.png',
      link: 'https://svoevagro.ru/students/ambassadors',
    },
    {
      name: 'Вакансии',
      description:
        'Собрали в одном месте самые интересные предложения: сортируй вакансии и получай работу',
      image: '/our-services/vacancies.png',
      link: 'https://svoevagro.ru/vacancies',
    },
    {
      name: 'Задания от компаний',
      description:
        'Участвуйте в челленджах от компаний, получайте призы и возможность попасть на стажировки для студентов',
      image: '/our-services/jobs-from-companies.png',
      link: 'https://svoevagro.ru/students/ambassadors/employers-tasks/',
    },
  ]
</script>

<style lang="scss" scoped>
  .our-services {
    > .title {
      margin-bottom: 32px;
      font-size: 32px;
      font-weight: 500;
      line-height: 40px;

      @include vp-1279 {
        margin-bottom: 24px;
      }

      @include vp-767 {
        margin-bottom: 16px;
        font-size: 24px;
        line-height: 32px;
      }
    }

    > .cards {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;

      @include vp-1279 {
        grid-template-columns: 1fr;
      }
    }

    > .cards > .card {
      overflow: hidden;
      position: relative;
      display: block;
      padding: 24px;
      border-radius: 20px;
      background-color: $color-default-white;
      cursor: pointer;
      text-decoration: none;
      color: inherit;
      transition: $trans-default;

      > .name {
        z-index: 5;
        margin-bottom: 8px;
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        color: $color-kiwi-50;
      }

      > .text {
        z-index: 5;
        max-width: 209px;
        font-size: 14px;
        line-height: 22px;
        color: $color-potato-90;

        @include vp-1279 {
          max-width: calc(100% - 159px);
        }

        @include vp-767 {
          max-width: calc(100% - 96px);
        }
      }

      > .image {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 183px;
        height: auto;

        @include vp-1279 {
          max-height: 100%;
        }

        @include vp-767 {
          width: 120px;
        }
      }

      &:hover {
        background: linear-gradient(261deg, #00bd00 30.02%, #005e00 99.34%);

        > .name,
        > .text {
          color: $color-default-white;
        }
      }
    }
  }
</style>
